import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SuppliersComponent } from './suppliers.component';
import { PendingSuppliersListComponent } from './pending-suppliers-list/pending-suppliers-list.component';
import { ApprovedSuppliersListComponent } from './approved-suppliers-list/approved-suppliers-list.component';
import { DeclinedSuppliersListComponent } from './declined-suppliers-list/declined-suppliers-list.component';

const routes: Routes = [
  {
    path: '',
    component: SuppliersComponent,
    children: [
      {
        path: 'pending',
        component: PendingSuppliersListComponent
      },
      {
        path: 'approved',
        component: ApprovedSuppliersListComponent
      },
      {
        path: 'declined',
        component: DeclinedSuppliersListComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SuppliersRoutingModule { }
